// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"df9cbd75","453":"a4da8736","457":"c3fbc737","551":"1f431da0","640":"f5654721"}[chunkId] + ".chunk.js";
};